import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

const Terms: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main className="pt-32 pb-20">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold text-slate-900 mb-8">Terms of Service</h1>
          <p className="text-sm text-slate-500 mb-8">Last updated: December 15, 2025</p>
          
          <div className="prose prose-slate max-w-none">
            <h2 className="text-2xl font-semibold text-slate-900 mt-8 mb-4">Agreement to Terms</h2>
            <p className="text-slate-600 mb-4">
              By accessing or using Adventive's services, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
            </p>

            <h2 className="text-2xl font-semibold text-slate-900 mt-8 mb-4">Use of Services</h2>
            <p className="text-slate-600 mb-4">
              You may use our services only for lawful purposes and in accordance with these Terms. You agree not to:
            </p>
            <ul className="list-disc pl-6 text-slate-600 mb-4 space-y-2">
              <li>Violate any applicable laws or regulations</li>
              <li>Infringe on the rights of others</li>
              <li>Attempt to gain unauthorized access to our systems</li>
              <li>Interfere with the proper functioning of our services</li>
              <li>Use our services to distribute malware or harmful content</li>
            </ul>

            <h2 className="text-2xl font-semibold text-slate-900 mt-8 mb-4">Account Responsibilities</h2>
            <p className="text-slate-600 mb-4">
              You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You agree to notify us immediately of any unauthorized use.
            </p>

            <h2 className="text-2xl font-semibold text-slate-900 mt-8 mb-4">Intellectual Property</h2>
            <p className="text-slate-600 mb-4">
              Our services and all content, features, and functionality are owned by Adventive and are protected by copyright, trademark, and other intellectual property laws.
            </p>

            <h2 className="text-2xl font-semibold text-slate-900 mt-8 mb-4">Limitation of Liability</h2>
            <p className="text-slate-600 mb-4">
              To the fullest extent permitted by law, Adventive shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or relating to your use of our services.
            </p>

            <h2 className="text-2xl font-semibold text-slate-900 mt-8 mb-4">Termination</h2>
            <p className="text-slate-600 mb-4">
              We may terminate or suspend your access to our services at any time, without prior notice or liability, for any reason, including breach of these Terms.
            </p>

            <h2 className="text-2xl font-semibold text-slate-900 mt-8 mb-4">Changes to Terms</h2>
            <p className="text-slate-600 mb-4">
              We reserve the right to modify these Terms at any time. We will notify you of any changes by posting the new Terms on this page.
            </p>

            <h2 className="text-2xl font-semibold text-slate-900 mt-8 mb-4">Contact Us</h2>
            <p className="text-slate-600 mb-4">
              If you have questions about these Terms, please contact us at legal@adventive.com.
            </p>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Terms;
